import { useEffect, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DialogContent, DialogActions } from '@mui/material';
import { useAuth } from '@app/api/auth/useAuth';
import { ThemeButton } from '@shared/ui/buttons';
import { CodePinInput } from '@shared/ui/forms/inputs';
import BlockLoader from '@shared/ui/messages/BlockLoader';
import { CopyToClipWhisper } from '@shared/ui/messages/CopyToClipWhisper';
import { validateServerErrors } from '@utils/validation';

export default function EnableTwofaDialog({ close }) {
  const [qrData, setQrData] = useState(null);
  const [isGenerateLoading, setGenerateLoading] = useState(true);
  const { generateTwofa, enableTwofa } = useAuth();
  const { t } = useTranslation();
  const {
    control,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      otp: '',
    },
  });
  const otpWatch = useWatch({ control, name: 'otp' });

  async function onSubmit(data) {
    try {
      const res = await enableTwofa(data, qrData);
      if (res) close();
    } catch (err) {
      validateServerErrors(setError, err);
    }
  }

  async function generate() {
    setQrData(await generateTwofa());
    setGenerateLoading(false);
  }

  useEffect(() => {
    generate();
  }, []);

  return (
    <>
      <DialogContent className="twoFa">
        <p>{t('scan_qr_code')}</p>
        {isGenerateLoading ? (
          <BlockLoader />
        ) : (
          <div className="twoFa__qr">
            <div dangerouslySetInnerHTML={{ __html: qrData?.qr_code }} />
            <p className="secondary-text">{t('secret_key')}</p>
            <CopyToClipWhisper
              value={qrData?.google2fa_secret}
              display={qrData?.google2fa_secret}
            />
          </div>
        )}
        <CodePinInput
          control={control}
          name="otp"
          error={errors.otp}
          label={t('enter_2fa_code')}
        />
      </DialogContent>
      <DialogActions>
        <ThemeButton
          onClick={handleSubmit(onSubmit)}
          startIcon="check"
          loading={isSubmitting}
          disabled={otpWatch.length < 6}
        >
          {t('submit')}
        </ThemeButton>
      </DialogActions>
    </>
  );
}
